.product-color {
  display: inline-block;
  vertical-align: middle;
  text-indent: 100%;
  border-radius: 0.1875rem;
  margin: 0 0.3125rem;
  overflow: hidden;
}